module.exports = __webpack_public_path__ + "static/media/sorting_increasing_icon.3968ca9a.svg";